export default __webpack_public_path__ + "locales/shop.ru.json";